module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg3-4aca6015254db1bb19fe80c6fe6775e1.jpg";